import React from 'react'

const CopyrightSection = () => {
  return (
    <div className='copyright-container'>
        <p>&copy; 2024 Wesa Pefa Academy | All rights reserved.</p>


    </div>
  )
}

export default CopyrightSection